import React, { useState } from "react";
import { formatRut, RutFormat } from "@fdograph/rut-utilities";
import {
  Card,
  CardContent,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TablePagination,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import * as locales from "@material-ui/core/locale";
import { Alert } from "@material-ui/lab";
import { useObtenerSociosClienteQuery } from "../../../services/accesoClientesApi";
import Scrollbar from "../../Scrollbar";
import TableSkeleton from "src/components/cliente/loading/TableSkeleton";
import EmptyState from "src/components/cliente/empty/EmptyState";

const styles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginBottom: theme.spacing(1),
  },
  pos: {
    marginBottom: 12,
  },
  headerCell: {
    fontWeight: 700,
    backgroundColor: "#F5F5F5",
    color: "#424242",
  },
}));

export default function SociosClienteSeleccionado(props) {
  const { value, cliente } = props;
  const classes = styles();
  const [locale] = useState("esES");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // RTK Query - Obtener socios del cliente
  const {
    data: socios = [],
    isLoading,
    isError,
    error,
  } = useObtenerSociosClienteQuery(cliente?.rut, {
    skip: !cliente?.rut || value !== 1,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={classes.pos}>
      {value === 1 && (
        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Typography variant="h5" component="h2" className={classes.title}>
              Socios
            </Typography>

            {/* Estado de carga */}
            {isLoading && <TableSkeleton rows={3} columns={2} />}

            {/* Estado de error */}
            {isError && (
              <Box mt={1}>
                <Alert severity="error">
                  Error al cargar los socios. Por favor, intenta nuevamente.
                  {error?.data?.message && ` (${error.data.message})`}
                </Alert>
              </Box>
            )}

            {/* Sin socios */}
            {!isLoading && !isError && socios.length === 0 && (
              <EmptyState
                title="Sin socios registrados"
                description="Este cliente no tiene socios asociados."
              />
            )}

            {/* Tabla de socios */}
            {!isLoading && !isError && socios.length > 0 && (
              <>
                <Scrollbar>
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small" aria-label="tabla de socios">
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.headerCell}>
                            Nombre
                          </TableCell>
                          <TableCell className={classes.headerCell}>
                            RUT
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {socios
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((socio, index) => (
                            <TableRow key={index} hover>
                              <TableCell>{socio.nombreCliente}</TableCell>
                              <TableCell>
                                {formatRut(
                                  socio.rutCliente,
                                  RutFormat.DOTS_DASH,
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>

                <ThemeProvider
                  theme={(outerTheme) =>
                    createTheme(outerTheme, locales[locale])
                  }
                >
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={socios.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </ThemeProvider>
              </>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
